import styled from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../styled components/Typography';
import SVGIcon from '../SVGIcon/SVGIcon';

export const SelectContainer = styled(Body).attrs(({ $hasError }) => ({
  className: `control-select ${$hasError ? 'has-error' : ''}`,
  as: 'div'
}))(() => [tw`max-w-xs`]);

export const SelectIcon = styled(SVGIcon).attrs(() => ({
  className: 'caret-icon'
}))(() => [tw`absolute right-0 mt-8 mr-8 text-black opacity-60`]);
